import useOrgAccess from '_/hooks/useOrgAccess';
import { OPS_INCLUDED } from '_/utils/userManagement';
import { ReactNode } from 'react';

interface PermitOpsEngineerProps {
  children: ReactNode;
}

function PermitOpsEngineer({ children }: PermitOpsEngineerProps): ReactNode {
  const enabled = useOrgAccess(OPS_INCLUDED);

  return enabled ? children : null;
}

export default PermitOpsEngineer;
